import { lazy } from "react";

const FieldDefList = lazy(() =>
  import("./FieldDefList").then((m) => ({ default: m.FieldDefList })),
);
const FieldDefCreate = lazy(() =>
  import("./FieldDefCreate").then((m) => ({ default: m.FieldDefCreate })),
);
const FieldDefEdit = lazy(() =>
  import("./FieldDefEdit").then((m) => ({ default: m.FieldDefEdit })),
);

export default {
  list: FieldDefList,
  create: FieldDefCreate,
  edit: FieldDefEdit,
  recordRepresentation: "name",
};
